import { SVGProps } from 'react';

export default function FooterOpen(props: Partial<SVGProps<any>>) {
  return (
<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48ZM26.3623 21.1505V17.5L31.8893 23.0261L26.3623 28.5531V24.5666C20.8347 24.5667 17.6855 24.6101 17 31.52C17 21.1869 23.0465 21.1506 26.3623 21.1505Z" fill="#CBCEEA"/>
</svg>  )
}